DJ.addBehavior('mag-running-slider', '.mag-banner', {
  attach: function(context, settings, behavior) {
    var $container = jQuery(this);
    var sliders = [];
    $container.find('.running-img').each(function() {
      var $slider = jQuery(this);

      if ($slider.hasClass('slick-initialized')) {
        return;
      }

      var $items = $slider.find('.running-img--item');
      if ($items.length < 2) {
        return;
      }
      $slider.on('init', function(event, slick) {
        $slider.addClass('is-autoplay');
        jQuery(this).find('.slick-autoplay-toggle-button').remove();
      });

      $slider.slick({
        vertical: true,
        autoplay: true,
        autoplaySpeed: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        easing: 'linear',
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        speed: 3000,
        transformEnabled: false,
        pauseButton: false,
        responsive: [
          {
            breakpoint: 974,
            settings: "unslick"
          }
        ]
      });

      sliders.push($slider);
    });

    var $playButton = $container.find('.js-mag-running-play');

    if ($playButton.length && sliders.length) {
      $playButton.off('click.magRunning').on('click.magRunning', function() {
        var isPlaying = sliders[0].hasClass('is-autoplay');

        if (isPlaying) {
          sliders.forEach(function($slider) {
            var $track = $slider.find('.slick-track');
            var computedTransform = window.getComputedStyle($track[0]).transform;
            $track.css('transform', computedTransform);
            $slider.slick('slickPause');
            $slider.removeClass('is-autoplay');
            $slider.addClass('is-paused');
          });
          $playButton.attr('aria-pressed', 'true');
          $playButton.attr('aria-label', 'Lancer l\'animation');
        } else {
          sliders.forEach(function($slider) {
            $slider.find('.slick-track').css('transform', '');
            $slider.removeClass('is-paused');
            $slider.addClass('is-autoplay');
            $slider.slick('slickPlay');
          });
          $playButton.attr('aria-pressed', 'false');
          $playButton.attr('aria-label', 'Arrêter l\'animation');
        }
      });
    }
  },

  detach: function(context, settings) {}
});
